import { useSelector } from 'react-redux'
import { useTranslation, Trans } from 'react-i18next'
import classNames from 'classnames'

import { ReactComponent as LockIcon } from '../../../assets/images/common/icons/lock-icon.svg'
import colors from '../../../assets/styles/globals.scss'
import Logo from '../../../assets/images/logos/full-brand-logo-dark.svg'
import ButtonLink from '../../common/buttons/ButtonLink'

import classes from './ExistingCommunityErrorSection.module.scss'

const ExistingCommunityErrorSection = () => {
  const { t } = useTranslation()
  const user = useSelector(state => state.user.current_user)
  const { community } = useSelector(state => state.landingAccess)

  return (
    <div className={classNames(classes.existingCommunityErrorSection, 'h-100 d-flex flex-column')}>
      <a href='https://operation36.golf' target='_blank' className='mb-3'>
        <img src={Logo} className='mb-4' alt={t('programs.accessCode.logoAlt')} width={180} />
      </a>

      <header className='mb-5'>
        <LockIcon className={classes.lockIcon} />
        <h1 className={classNames(classes.title, 'mt-3')}>{t('programs.accessCode.existingCommunity.title')}</h1>
      </header>

      <p className='my-2'>
        <Trans
          i18nKey='programs.accessCode.existingCommunity.belongsToOther'
          components={{ b: <span style={{ fontWeight: '700' }} /> }}
          values={{ pageCommunity: community?.name, memberCommunity: user?.communities?.[0]?.name }}
        />
        <br/><br/>
        {t('programs.accessCode.existingCommunity.oneCommunityOnly')}
        <br/><br/>
        <Trans
          i18nKey='programs.accessCode.existingCommunity.transferOrQuestions'
          components={{
            b: <span style={{ fontWeight: '700' }} />,
            email: <span style={{ color: colors.secondaryColor, textDecoration: 'underline' }} />,
          }}
          values={{ pageCommunity: community?.name }}
        />
      </p>

      <ButtonLink navigateTo={`/landing/${user?.communities?.[0]?.id}`} className={classNames(classes.navigateLink, 'mt-5')} isExternal >
        {t('programs.accessCode.existingCommunity.backToMyCommunity')}
      </ButtonLink>
    </div>
  )
}

export default ExistingCommunityErrorSection
